type SupplierTreeCountry = {
  name: string | null;
};

type SupplierTreeLabelSource = {
  name: string | null;
  country: SupplierTreeCountry | null;
  isFolder: boolean | null;
};

type SupplierTreeLabelOptions = {
  fallback?: string;
};

export const formatSupplierTreeLabel = (
  supplier: SupplierTreeLabelSource | null | undefined,
  options: SupplierTreeLabelOptions = {},
): string => {
  const fallback = options.fallback ?? 'Unknown supplier';

  if (!supplier) {
    return fallback;
  }

  const parts = [supplier.name];

  if (supplier.country?.name && !supplier.isFolder) {
    parts.push(supplier.country.name);
  }

  return parts.filter(Boolean).join(' - ') || fallback;
};
